// Copyright (c) StrangeBee 2023

import { ReportTemplateController, ReportTemplateInput, ReportTemplateOutput } from 'thehive-sdk';

export interface ReportTemplateEventList {
    onCreate: (reportTemplate: ReportTemplateInput) => Promise<ReportTemplateOutput | void>;
    onEdit: (reportTemplate: ReportTemplateInput, reportTemplateId: string) => Promise<void>;
    onDelete: (reportTemplateId: string) => void;
}

interface ReportTemplateEventListParams {
    locale?: (label: string) => string;
    controller: ReportTemplateController;
    onSuccess?: (count?: boolean, message?: string) => void;
    onError?: (label?: string) => void;
}

export const computeEventList = ({
    controller,
    locale,
    onError,
    onSuccess,
}: ReportTemplateEventListParams): ReportTemplateEventList => ({
    onCreate: (reportTemplate) =>
        controller
            .create<ReportTemplateInput, ReportTemplateOutput>(reportTemplate)
            .then((created) => {
                onSuccess?.(true, locale?.('notification.report-template.create'));
                return created;
            })
            .catch(onError),
    onEdit: (reportTemplate, reportTemplateId) =>
        controller
            .edit(reportTemplate, reportTemplateId)
            .then(() => onSuccess?.(true, locale?.('notification.report-template.edit')))
            .catch(onError),
    onDelete: (reportTemplateId) =>
        controller
            .delete(reportTemplateId)
            .then((): void => onSuccess?.(true, locale?.('notification.report-template.delete')))
            .catch(onError),
});
